module.exports = "<div class=\"income-vs-expense-graph\">\n  <canvas class=\"chart\" #barChart>{{ chart }}</canvas>\n</div>"